import USER_ROLES from 'constants/user-roles.constant';
import { restrictions } from 'state/features-list/constants';

const childCareModule = {
  name: 'childCare',
  url: '/child-care',
  resolver: () => import(/* webpackChunkName: "child-care" */ './child-care'),
  restrictions: {
    user: [restrictions['eap']],
  },
  data: {
    title: 'components.main_menu.child_care',
    mainMenu: 'childCare',
    section: 'life',
    includeInMenu: false,
    order: 2,
    authorizedRoles: [USER_ROLES.employee],
  },
};

export default childCareModule;
